import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/auth/admin`,
});

const STAFF_API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/staff-auth/staff`,
});

// ═══════════════════════════════════════════════════════════════════════
// ✅ NEW — OTP-based login (2-step)
// Step 1: verify email+password → server emails a 6-digit OTP
// Step 2: verify OTP → server returns the real token
// ═══════════════════════════════════════════════════════════════════════

// Organization / Admin — Step 1
// POST /api/auth/admin/login   { email, password }
// NOTE: backend (authController.js) needs to be updated to match this
// 2-step flow — see the reference pattern shared alongside staffController.js.
export const loginAdminSendOTP = async (payload) => {
  const res = await API.post("/login", payload);
  return res.data;
};

// Organization / Admin — Step 2
// POST /api/auth/admin/login/verify-otp   { email, otp }
export const loginAdminVerifyOTP = async (payload) => {
  const res = await API.post("/login/verify-otp", payload);
  return res.data;
};

// Staff — Step 1
// POST /api/staff-auth/staff/login   { email, password }
export const loginStaffSendOTP = async (payload) => {
  const res = await STAFF_API.post("/login", payload);
  return res.data;
};

// Staff — Step 2
// POST /api/staff-auth/staff/login/verify-otp   { email, otp }
export const loginStaffVerifyOTP = async (payload) => {
  const res = await STAFF_API.post("/login/verify-otp", payload);
  return res.data;
};

// ═══════════════════════════════════════════════════════════════════════
// Legacy single-step functions — kept as-is in case anything else in the
// app still imports these. Not used by the new OTP login flow in Login.jsx.
// ═══════════════════════════════════════════════════════════════════════
export const loginAdmin = async (payload) => {
  const res = await API.post("/login", payload);
  return res.data;
};

export const registerAdmin = async (payload) => {
  const res = await API.post("/register", payload);
  return res.data;
};

export const loginStaff = async (payload) => {
  const res = await STAFF_API.post("/login", payload);
  return res.data;
};

// ── Forgot Password (Admin / Organization) ───────────────────────────────
// Step 1: Send OTP to email
// POST /api/auth/admin/forgot-password/send-otp
export const forgotPasswordSendOTP = async (payload) => {
  const res = await API.post("/forgot-password/send-otp", payload);
  return res.data;
};

// Step 2: Verify OTP and reset password
// POST /api/auth/admin/forgot-password/verify-otp-reset
export const forgotPasswordVerifyOTPAndReset = async (payload) => {
  const res = await API.post("/forgot-password/verify-otp-reset", payload);
  return res.data;
};

export const forgotStaffPasswordSendOTP = async (payload) => {
  const res = await STAFF_API.post("/forgot-password/send-otp", payload);
  return res.data;
};

export const forgotStaffPasswordVerifyOTPAndReset = async (payload) => {
  const res = await STAFF_API.post(
    "/forgot-password/verify-otp-reset",
    payload,
  );
  return res.data;
};

export const changeAdminPassword = async (payload) => {
  const res = await API.post("/change-password", payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

export const changeStaffPassword = async (payload) => {
  const res = await STAFF_API.post("/change-password", payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

export const getAdminProfile = async () => {
  const res = await API.get("/profile", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

export const getStaffProfile = async () => {
  const res = await STAFF_API.get("/profile", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

export const updateAdminProfile = async (payload) => {
  const res = await API.put("/profile", payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

export const updateStaffProfile = async (payload) => {
  const res = await STAFF_API.put("/profile", payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

// ── TOTP 2FA (Google Authenticator) ───────────────────────────────────────
export const setupTwoFactor = async () => {
  const res = await API.post(
    "/2fa/setup",
    {},
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } },
  );
  return res.data;
};

export const verifyTwoFactorSetup = async (payload) => {
  const res = await API.post("/2fa/verify-setup", payload, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data;
};

export const disableTwoFactor = async (payload) => {
  const res = await API.post("/2fa/disable", payload, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data;
};

export const loginAdminVerifyTOTP = async (payload) => {
  const res = await API.post("/login/verify-totp", payload);
  return res.data;
};
